import React from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import styled from "styled-components";

const SecondaryTabs = ({ tabsInfo }) => {
  const tabList = tabsInfo.map(({ text }) => text);
  const tabPanelList = tabsInfo.map(({ TapPanelContent }) => TapPanelContent);
  console.log(tabPanelList);
  return (
    <Tabs>
      <StyledTabList
        className={"flex bg-secondary-600 text-sm font-semibold my-5 border-b"}
      >
        {tabList.map((tab, index) => {
          return (
            <Tab
              key={index}
              className="py-3 px-[27px] cursor-pointer min-w-[120px] flex justify-center items-center transition-all duration-300 hover:bg-gray-200 border-b-2 border-transparent"
            >
              {tab}
            </Tab>
          );
        })}
      </StyledTabList>

      {tabPanelList.map((Panel, index) => {
        return (
          <TabPanel key={index}>
            <Panel />
          </TabPanel>
        );
      })}
    </Tabs>
  );
};

const StyledTabList = styled(TabList)`
  .react-tabs__tab--selected {
    border-bottom: 2px solid #e66553;
    color: #e66553;
  }
`;

export default SecondaryTabs;
